import React, { useCallback, useEffect } from 'react';
import { Image, Timeline } from 'antd';
import NewMeetingHistory from 'modules/meeting-history/new';
import Request from 'common/network/Request';
import meetingHistoryApis from 'modules/meeting-history/api';
import _ from 'lodash';
import dayjs from 'dayjs';

const MeetingHistory = ({ item = {}, onFetchMeetingSuccess }) => {
  const [histories, setHistories] = React.useState([]);
  const [loading, setLoading] = React.useState(false);

  const itemId = item.id;

  const getData = useCallback(async () => {
    setLoading(true);
    try {
      const response = await Request.get(
        meetingHistoryApis.get_meeting_history,
        {
          id: itemId,
        },
      );

      const items = _.map(
        _.orderBy(response?.result, 'meeting_timestamp', 'desc'),
        (item) => {
          const time = dayjs.unix(item.meeting_timestamp);
          const isBefore1Day = time.isBefore(dayjs().add(1, 'day'));
          const timeFormatted = time.clone().format('HH:mm DD/MM/YYYY');
          const images = item.images;

          return {
            children: (
              <div className="grid grid-cols-12 gap-2">
                <div className="col-span-8">
                  <div title={timeFormatted} className="text-gray-500">
                    {!isBefore1Day ? timeFormatted : time.fromNow()}
                  </div>
                  <div>
                    <div>{item.note}</div>
                  </div>
                </div>
                <div className="col-span-4">
                  {!_.isEmpty(images) ? (
                    <div className="flex mt-2 gap-2 flex-col">
                      <Image.PreviewGroup
                        items={_.reverse(
                          _.flatMap(response?.result, (item) =>
                            _.reverse(_.map(item.images, 'url')),
                          ).filter(Boolean),
                        )}
                      >
                        {_.map(images, (image) => (
                          <Image
                            key={image.id}
                            src={image.url}
                            alt={item.note}
                            className="object-contain block"
                          />
                        ))}
                      </Image.PreviewGroup>
                    </div>
                  ) : null}
                </div>
              </div>
            ),
          };
        },
      );

      if (typeof onFetchMeetingSuccess === 'function') {
        onFetchMeetingSuccess(items);
      }

      setHistories(items);
    } catch (error) {}
    setLoading(false);
  }, [itemId]);

  useEffect(() => {
    getData();
  }, [getData]);

  return (
    <div>
      <Timeline items={histories} pending={loading && 'Đang tải...'} />
      <NewMeetingHistory item={item} onSuccess={getData} />
    </div>
  );
};

export default MeetingHistory;
